module.exports = __webpack_public_path__ + "static/media/poliquel_zn.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/poliquel_zn.png
// module id = 1308
// module chunks = 3